<!--
 * @Description: ''
 * @Author: yangruonan(yangruonan@hztianque.com)
 * @Date: 2021-04-28 16:29:55
 * @LastEditTime: 2021-05-10 09:42:31
-->
<template>
  <div class="inventory-mask">
    <Modal
      v-model="showOfflineModel"
      :mask-closable="false"
      title="线下预约"
      @on-cancel="cancelModel">
      <Form
        ref="formOffline"
        :model="formOffline"
        :label-width="80"
        :rules="ruleValidate">
        <FormItem label="扣除余量" prop="stock">
          <Input
            v-model="formOffline.stock"
            type="number"
            placeholder="请输入正整数数字"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancelModel">取消</Button>
        <Button type="primary" :loading="loading" @click="asyncSaveOK('formOffline')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
    showOffline: {
      type: Boolean,
      default: false,
    },
    formValidate: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showOfflineModel: this.showOffline,
      formOffline: {
        stock: null,
      },
      loading: false,
      ruleValidate: {
        stock: [
          { required: true, message: '请输入正整数数字', trigger: 'blur,change' },
          {
            // eslint-disable-next-line no-unused-vars
            validator: (rule, value, callback) => {
              const reg = /^\+?[1-9][0-9]*$/ //正整数
              if (reg.test(value)) {
                callback()
              } else {
                callback('请输入正整数数字')
              }
            },
            trigger: 'blur,change',
          },
        ],
      },
    }
  },
  watch: {
    showOffline(val) {
      this.showOfflineModel = val
      if (val) {
        this.$refs['formOffline'].resetFields()
      }
    },
  },
  methods: {
    // 关闭
    cancelModel() {
      this.showOfflineModel = false
      this.$refs['formOffline'].resetFields()
      this.$emit('showModel', false)
    },
    // 确定
    asyncSaveOK(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true
          if (this.formValidate.stock < Number(this.formOffline.stock)) {
            this.$Message.error('酒店剩余库存不足!')
            this.loading = false
            return
          }
          this.updateReserve({stock: this.formOffline.stock, id: this.id}).then(res => {//eslint-disable-line
            if (res.code === '0' && res.flag === '0') {
              this.$Message.success('修改成功!')
              this.cancelModel()
              this.$emit('showModel', { modal: false, type: 'update' })
              this.loading = false
            }
          }).catch(err => {
            this.$Message.error(err.message)
          })
        }
      })
    },
    ...mapActions({
      updateReserve: 'jurisprudenceDaily/hotelManagement/updateReserve',
    }),
  },
}
</script>
<style lang="scss" scoped>

</style>